import React from 'react';
import styled from 'styled-components';

interface IconProps {
  name: string;
  size?: number;
  color?: string;
}

// Simple icon component using Unicode/Emoji icons
// In production, you'd use a proper icon library like react-icons or Shopify Polaris icons
const IconMap: Record<string, string> = {
  home: '🏠',
  orders: '📦',
  products: '🛍️',
  customers: '👥',
  analytics: '📊',
  marketing: '📢',
  discounts: '🎫',
  settings: '⚙️',
  search: '🔍',
  bell: '🔔',
  help: '❓',
  user: '👤',
  chevronDown: '▼',
  chevronRight: '▶',
  close: '✕',
  check: '✓',
  plus: '+',
  edit: '✏️',
  delete: '🗑️',
  filter: '🔽',
  sort: '⇅',
  categories: '📁',
  collections: '📚',
  variants: '🎨',
  truck: '🚚',
  inventory: '📋',
  voucher: '🎟️',
  shipping: '📮',
  store: '🏪',
  blog: '📝',
  page: '📄',
  star: '⭐',
  channels: '📡',
};

const StyledIcon = styled.span<{ size?: number; color?: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.size ? `${props.size}px` : '16px'};
  color: ${props => props.color || 'inherit'};
  line-height: 1;
`;

export const Icon: React.FC<IconProps> = ({ name, size, color }) => {
  const icon = IconMap[name] || '?';
  return <StyledIcon size={size} color={color}>{icon}</StyledIcon>;
};

export default Icon;

